"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyArray = void 0;
class PropertyArray {
    get answerableSelectors() {
        return this._selectors;
    }
    constructor(property) {
        this.property = property;
        this._selectors = [];
        this.mapChildrenAncestors();
        this.mapChildrenAnswerableSelectors();
    }
    _mapChildrenAncestors(props, arrayUID) {
        props.forEach((prop) => {
            prop.arrayUID = arrayUID;
            if (prop.hasChildProps()) {
                this._mapChildrenAncestors(prop.childProps(), arrayUID);
            }
        });
    }
    mapChildrenAncestors() {
        this._mapChildrenAncestors(this.property.childProps(), this.property.UID);
    }
    _mapChildrenAnswerableSelectors(props) {
        props.forEach((prop) => {
            if (prop.isAnswerable()) {
                this._selectors.push(prop.UID);
            }
            if (prop.hasChildProps()) {
                this._mapChildrenAnswerableSelectors(prop.childProps());
            }
        });
    }
    mapChildrenAnswerableSelectors() {
        this._selectors = [];
        this._mapChildrenAnswerableSelectors(this.property.childProps());
    }
}
exports.PropertyArray = PropertyArray;
